/* Zafira: cart drawer helpers (theme cart drawer, look of snippets/cart-drawer.liquid).
   1) Every "add to cart" made by our own blocks (combos, mixed grid, Complete your look, swap carousels...) refreshes and opens the cart drawer.
      Adds made by the theme itself already do it (they ask for "sections"), so they are skipped here.
   2) "Add a 2nd bag, it's FREE" carousel in the drawer: arrows, colour photo and Add button.
   3) Review stars on every product card (home collection tabs, collections, search, recommendations): green squares with the rating and the
      number of reviews, read from BK Reviews (one request for many products). Cards: <product-card data-product-id> and the home tabs
      <div class="zct__card" data-product-id>.
      Products WITHOUT reviews show the STORE rating instead (same green stars, "Store rating"): it is calculated from the reviews of ALL the
      products (average weighted by the number of reviews) and kept for 6 hours in the browser. It is labelled as the store rating on purpose,
      so nobody takes it for a review of that product. */
(function () {
  if (window.__zafiraCart) return;
  window.__zafiraCart = true;

  var origFetch = window.fetch;

  function sectionId() {
    var c = document.querySelector('cart-items-component');
    return c && c.dataset.sectionId;
  }

  function refresh() {
    var id = sectionId();
    if (!id) return Promise.resolve();
    return origFetch(window.location.pathname + '?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        return origFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'zafira', data: { source: 'zafira', itemCount: cart.item_count, sections: sections } }
          }));
        });
      })
      .catch(function () {});
  }
  window.zafiraRefreshCart = refresh;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var body = init && init.body;
    var themeAdd = false;
    if (typeof body === 'string') themeAdd = body.indexOf('sections') !== -1;
    else if (body && typeof body.has === 'function') themeAdd = body.has('sections');
    var p = origFetch.apply(this, arguments);
    if (isAdd && !themeAdd) {
      p.then(function (res) { if (res && res.ok) setTimeout(refresh, 0); }).catch(function () {});
    }
    return p;
  };

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-zcd-var]');
    if (!sel) return;
    var card = sel.closest('.zcd-up__card');
    var img = card && card.querySelector('.zcd-up__img img');
    if (!img) return;
    var src = sel.options[sel.selectedIndex].getAttribute('data-img');
    img.src = src || img.getAttribute('data-orig') || img.src;
  });

  document.addEventListener('click', function (e) {
    var sc = e.target.closest && e.target.closest('[data-zcd-scroll]');
    if (sc) {
      var list = sc.closest('.zcd-up').querySelector('[data-zcd-list]');
      list.scrollBy({ left: Number(sc.getAttribute('data-zcd-scroll')) * list.clientWidth, behavior: 'smooth' });
      return;
    }
    var add = e.target.closest && e.target.closest('[data-zcd-add]');
    if (!add || add.disabled) return;
    var sel = add.closest('.zcd-up__card').querySelector('[data-zcd-var]');
    var label = add.textContent;
    add.disabled = true;
    add.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(sel.value), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed'); refresh();
    }).catch(function () {
      add.textContent = label;
      add.disabled = false;
    });
  });
})();

/* the blocks of the store announce every add with this event: refresh and open the drawer */
document.addEventListener('zafira:cart-added', function () { if (window.zafiraRefreshCart) window.zafiraRefreshCart(); });

/* review stars on the product cards */
(function () {
  if (window.__zafiraCardStars) return;
  window.__zafiraCardStars = true;
  var shop = window.Shopify && window.Shopify.shop;
  if (!shop) return;
  var API = 'https://bk-reviews-shopify-backend-production.up.railway.app/reviews/' + shop + '/metadata/collection/?product_ids=';
  var CARDS = 'product-card[data-product-id], .zct__card[data-product-id]';
  var SKEY = 'zafira_store_rating_v1';
  var STAR = '<svg viewBox="0 0 24 24" width="12" height="12" fill="#fff" aria-hidden="true"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6L2.5 9.4l6.6-.8z"/></svg>';
  var cache = {};
  var asked = {};
  var timer = null;
  var store = null; // { avg, n, t } = rating of the whole store

  var css = document.createElement('style');
  css.textContent = '.zst{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:4px 6px;margin:6px 0 2px;font-size:12px;color:#444;line-height:1}' +
    '.zst__row{display:inline-flex;gap:2px}' +
    '.zst__s{width:17px;height:17px;display:inline-flex;align-items:center;justify-content:center;background:#dcdce6}' +
    '.zst__t b{color:#111;font-weight:700}.zst__t i{font-style:normal;color:#777}' +
    '.zct__card .zst-host{display:flex;justify-content:center}';
  document.head.appendChild(css);

  function stars(avg) {
    var s = '';
    for (var i = 1; i <= 5; i++) {
      var f = Math.max(0, Math.min(1, avg - (i - 1))) * 100;
      s += '<span class="zst__s" style="background:linear-gradient(90deg,#00b67a ' + f + '%,#dcdce6 ' + f + '%)">' + STAR + '</span>';
    }
    return s;
  }

  function html(m) {
    var avg = Number(m.average_rating) || 0, n = Number(m.qty_general_rating) || 0;
    return '<span class="zst__row" role="img" aria-label="Rated ' + avg.toFixed(1) + ' out of 5">' + stars(avg) + '</span><span class="zst__t"><b>' + avg.toFixed(1) + '</b> <i>(' + n + ')</i></span>';
  }

  function storeHtml() {
    return '<span class="zst__row" role="img" aria-label="Store rating ' + store.avg.toFixed(1) + ' out of 5">' + stars(store.avg) + '</span><span class="zst__t" title="Average of ' + store.n + ' customer reviews in our store"><b>' + store.avg.toFixed(1) + '</b> <i>Store rating</i></span>';
  }

  function paint() {
    document.querySelectorAll(CARDS).forEach(function (c) {
      if (c.querySelector('.zst')) return;
      var m = cache[c.getAttribute('data-product-id')];
      var own = m && Number(m.qty_general_rating) > 0;
      if (!m) return; // wait for the answer of the reviews service before deciding
      if (!own && !store) return;
      var box = c.querySelector('.estrelas-avaliacao');
      if (!box && c.classList.contains('zct__card')) {
        var lk = c.querySelector('.zct__link');
        if (!lk) return;
        box = document.createElement('div');
        box.className = 'zst-host';
        lk.insertAdjacentElement('afterend', box);
      }
      if (!box) return;
      var el = document.createElement('div');
      el.className = 'zst';
      el.innerHTML = own ? html(m) : storeHtml();
      box.appendChild(el);
    });
  }

  // rating of the whole store: average of every product's rating weighted by its number of reviews
  function loadStore() {
    try {
      var c = JSON.parse(localStorage.getItem(SKEY) || 'null');
      if (c && c.avg > 0 && Date.now() - c.t < 6 * 3600 * 1000) { store = c; paint(); return; }
    } catch (e) {}
    fetch('/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ids = (d.products || []).map(function (p) { return String(p.id); });
        var chunks = [];
        while (ids.length) chunks.push(ids.splice(0, 24));
        var sum = 0, n = 0;
        return Promise.all(chunks.map(function (ch) {
          return fetch(API + ch.join(',')).then(function (r) { return r.json(); }).then(function (arr) {
            (Array.isArray(arr) ? arr : []).forEach(function (m) {
              var q = Number(m.qty_general_rating) || 0;
              cache[String(m.product_id)] = m;
              if (q > 0) { sum += q * (Number(m.average_rating) || 0); n += q; }
            });
          });
        })).then(function () {
          if (n > 0) {
            store = { avg: sum / n, n: n, t: Date.now() };
            try { localStorage.setItem(SKEY, JSON.stringify(store)); } catch (e) {}
            paint();
          }
        });
      })
      .catch(function () {});
  }

  function run() {
    var ids = [];
    document.querySelectorAll(CARDS).forEach(function (c) {
      var id = c.getAttribute('data-product-id');
      if (id && !asked[id] && !c.closest('.zcd')) { asked[id] = true; ids.push(id); }
    });
    var chunks = [];
    while (ids.length) chunks.push(ids.splice(0, 24));
    chunks.forEach(function (ch) {
      fetch(API + ch.join(','))
        .then(function (r) { return r.json(); })
        .then(function (arr) {
          (Array.isArray(arr) ? arr : []).forEach(function (m) { cache[String(m.product_id)] = m; });
          paint();
        })
        .catch(function () { ch.forEach(function (id) { delete asked[id]; }); });
    });
    paint();
  }

  function later() { clearTimeout(timer); timer = setTimeout(run, 300); }
  loadStore();
  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
})();
